/**
 * Has this order line actually changed since it was loaded? OrderEdit's
 * handleSave uses this to skip re-PUTting a line (and its allocation plan)
 * that's untouched — needed because the backend rejects any order_items/
 * allocation write once the order is already shipped/delivered, even a
 * no-op one, so a pure status change (e.g. shipped -> delivered with no
 * item edits) would otherwise always fail.
 */
export const lineUnchanged = (line) => {
  if (line.isNew || !line._original) return false;
  const o = line._original;
  return line.variant?.id === o.variantId
    && Number(line.quantity) === Number(o.quantity)
    && (Number(line.price_ils) || 0) === (Number(o.price_ils) || 0)
    && (Number(line.price_usd) || 0) === (Number(o.price_usd) || 0)
    && JSON.stringify(line.allocationValue) === o.allocation;
};
